import { useState } from 'react';
import { Link } from 'react-router-dom';
import ReportingSubLinks from '../../components/header/ReportingSubLinks.jsx';
import BackArrow from '../../components/common/BackArrow.jsx';
import AuditTicketsForm from '../../components/reporting/AuditTicketsForm.jsx';
import CompletedAuditsView from '../../components/reporting/CompletedAuditsView.jsx';
import useCurrentUser from '../../hooks/useCurrentUser.js';
import LoadingSpinner from '../../components/common/LoadingSpinner.jsx';

/**
 * Component for rendering the page for Audit Ticket tool.
 * @returns {JSX.Element} AuditTicketPage component.
 */
const AuditTicketPage = () => {
    const [mainView, setMainView] = useState('audit');
    const {
        loading,
        canAccessWeeklyAudit,
        canManageTeams,
        isLeadership,
        isTeamLead,
        user
    } = useCurrentUser();

    if (loading) {
        return <LoadingSpinner />;
    }

    if (!canAccessWeeklyAudit) {
        return (
            <div
                style={{
                    minHeight: '50vh',
                    padding: '2rem',
                    maxWidth: 540,
                    margin: '0 auto'
                }}>
                <h2 style={{ marginTop: 0 }}>Audit tickets</h2>
                <p style={{ color: '#475569', lineHeight: 1.5 }}>
                    Weekly audit is available to <strong>team leads</strong>{' '}
                    (for their team) and <strong>IT leadership</strong> (all
                    teams). If you need access, ask an administrator to assign
                    the team-lead flag or the Oracle weekly-audit permission for
                    your role.
                </p>
                <p>
                    <Link to="/reporting">Back to reporting</Link>
                </p>
            </div>
        );
    }

    return (
        <div
            style={{
                height: 'calc(100vh - 75px)',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
                background: '#f8fafc'
            }}>
            <ReportingSubLinks />
            <div
                className="newsc-container"
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    flex: 1,
                    overflow: 'hidden',
                    background: '#f8fafc'
                }}>
                <div
                    style={{
                        background: '#ffffff',
                        padding: '20px 0',
                        borderBottom: '1px solid #e5e7eb',
                        flexShrink: 0,
                        zIndex: 5
                    }}>
                    <div
                        className="create-office-heading audit-ticket-page__heading"
                        style={{
                            margin: '0 auto',
                            padding: '0 1.25rem',
                            boxShadow: 'none',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            gap: '1rem',
                            flexWrap: 'wrap'
                        }}>
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '0.75rem',
                                flexWrap: 'wrap'
                            }}>
                            <BackArrow noMarginRight navigateTo={-1} />
                            <h2 style={{ margin: 0 }}>Audit tickets</h2>
                            {canManageTeams ? (
                                <Link
                                    className="btn btn-secondary"
                                    // style={{
                                    //     marginLeft: 'auto',
                                    //     paddingBlock: '0.5em',
                                    //     paddingInline: '1em',
                                    //     borderRadius: '0.5em',
                                    //     backgroundColor: '#f8fafc',
                                    //     color: '#374151',
                                    //     textDecoration: 'none',
                                    //     fontSize: '0.875rem',
                                    //     fontWeight: '500',
                                    //     transition: 'all 0.2s ease-in-out'
                                    // }}
                                    to="/manage-users">
                                    Team management
                                </Link>
                            ) : null}
                        </div>
                        <div
                            className="audit-ticket-page__toggle"
                            role="tablist"
                            aria-label="Audit view">
                            <button
                                type="button"
                                role="tab"
                                aria-selected={mainView === 'audit'}
                                className={`audit-ticket-page__toggle-btn ${
                                    mainView === 'audit'
                                        ? 'audit-ticket-page__toggle-btn--active'
                                        : ''
                                }`}
                                onClick={() => setMainView('audit')}>
                                Audit tech
                            </button>
                            <button
                                type="button"
                                role="tab"
                                aria-selected={mainView === 'completed'}
                                className={`audit-ticket-page__toggle-btn ${
                                    mainView === 'completed'
                                        ? 'audit-ticket-page__toggle-btn--active'
                                        : ''
                                }`}
                                onClick={() => setMainView('completed')}>
                                Completed audits
                            </button>
                        </div>
                    </div>
                </div>

                <div
                    style={{
                        flex: 1,
                        overflowY: 'auto',
                        paddingTop: '1.25rem'
                    }}>
                    {mainView === 'audit' ? (
                        <AuditTicketsForm
                            isLeadership={!!isLeadership}
                            isTeamLead={!!isTeamLead}
                            hdTeam={user?.hdTeam}
                        />
                    ) : (
                        <CompletedAuditsView />
                    )}
                </div>
            </div>
        </div>
    );
};

export default AuditTicketPage;
